<template>
	<div class="mt-4">
		<b-container class="p-0 m-0 data-volume-region-container">
			<card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
				<template slot="header">
					<b-row slot="header">
						<b-col>
							<span class="h4 font-weight-bold mb-0 nowrap" v-if="title">{{ title }}</span>
						</b-col>
						<b-col class="font-weight-bold mb-0 text-right nowrap">
							<span class="h6 font-weight-bold mb-0" v-if="cTitle">
								<base-button
									size="xs"
									type="secondary"
									class="p-1 border-radius-none"
									@click="changeDataRegionTab(cTitle)"
									v-bind:class="btnActivated === cTitle ? 'bg-warning text-white' : ''"
									>{{ cTitle }}</base-button
								>
							</span>
							<span class="h6 font-weight-bold mb-0" v-if="dTitle">
								<base-button
									size="xs"
									type="secondary"
									class="p-1 border-radius-none"
									@click="changeDataRegionTab(dTitle)"
									v-bind:class="btnActivated === dTitle ? 'bg-warning text-white' : ''"
									>{{ dTitle }}</base-button
								>
							</span>
							<span class="h6 font-weight-bold mb-0" v-if="mTitle">
								<base-button
									size="xs"
									type="secondary"
									class="p-1 border-radius-none"
									@click="changeDataRegionTab(mTitle)"
									v-bind:class="btnActivated === mTitle ? 'bg-warning text-white' : ''"
								>
									{{ mTitle }}</base-button
								>
							</span>
							<span class="h6 font-weight-bold mb-0" v-if="yTitle">
								<base-button
									size="xs"
									type="secondary"
									class="p-1 mr-1 border-radius-none"
									@click="changeDataRegionTab(yTitle)"
									v-bind:class="btnActivated === yTitle ? 'bg-warning text-white' : ''"
								>
									{{ yTitle }}</base-button
								>
							</span>
							<slot name="icon" class="pl-2">
								<b-icon
									icon="question-circle"
									variant="orange"
									class="mr-1 vertical-align-35"
									v-b-tooltip.hover
									:title="tooltip"
								></b-icon>
							</slot>
							<slot name="icon" class="pl-2 ml-2">
								<b-icon
									:icon="icon1"
									variant="orange"
									class="vertical-align-35"
									@click="dataVolumeRegionToggle()"
								></b-icon>
							</slot>
						</b-col>
					</b-row>
				</template>
				<transition name="slide-fade">
					<b-row v-if="toggleStatus">
						<div class="text-center w-100">
							<b-icon
								icon="three-dots"
								class="text-center"
								animation="cylon"
								font-scale="4"
								v-if="loadingStatus"
							></b-icon>
						</div>
						<b-col v-if="!loadingStatus">
							<b-card no-body class="border-0 mb-0">
								<div id="data_volume_map" class="map-canvas" style="height: 600px"></div>
								<div :id="'legend' + btnActivated" class="br-white mr-2"></div>
							</b-card>
						</b-col>
					</b-row>
				</transition>
			</card>
		</b-container>
	</div>
</template>

<script>
import cardOpenStatusDirective from "@/common/directive/card-open-status-directive";
import configDirective from "@/common/directive/config-directive";
import moment from "moment";

export default {
	props: {
		type: {
			type: String,
			default: "primary",
		},
		icon: String,
		title: String,
		cTitle: String,
		dTitle: String,
		mTitle: String,
		yTitle: String,
		iconClasses: [String, Array],
		tooltip: String,
	},
	data() {
		return {
			toggleStatus: false,
			loadingStatus: true,
			initialLoad: true,
			icon1: "arrow-right-square",
			downIcon: "arrow-down-square",
			rightIcon: "arrow-right-square",
			btnActivated: "Current",
			lat: 0,
			lng: 0,
			weight: 0,
			color: "#5e72e4",
			markerList: [],
			gradient: [
				"rgba(102, 255, 0, 0)",
				"rgba(102, 255, 0, 1)",
				"rgba(147, 255, 0, 1)",
				"rgba(193, 255, 0, 1)",
				"rgba(238, 255, 0, 1)",
				"rgba(244, 227, 0, 1)",
				"rgba(249, 198, 0, 1)",
				"rgba(255, 170, 0, 1)",
				"rgba(255, 113, 0, 1)",
				"rgba(255, 57, 0, 1)",
				"rgba(255, 0, 0, 1)",
			],
		};
	},

	async mounted() {
		this.getCardStatus();

		this.$root.$on("dataVolumeTrendByRegion", event => {
			try {
				//console.log('ON dataVolumeTrendByRegion ')
				setTimeout(() => {
					this.initMap(google, event);
				}, 5200);
				this.loadingStatus = false;
			} catch (e) {
				//console.error('ON dataVolumeTrendByRegion');
				console.error(e);
			}
		});
	},
	methods: {
		getCardStatus() {
			if (cardOpenStatusDirective.getOpenCardStatus()) {
				let cardStatus = cardOpenStatusDirective.getOpenCardStatus()["dataVolume-map-collapse"];
				if (cardStatus) {
					this.icon1 = this.downIcon;
					this.toggleStatus = cardStatus;
				}
			}
		},

		checkMapData(data) {
			// console.log('checkMapData:',data);
			if (data.length === 0) {
				return true;
			} else if (data.length === 1 && data[0].imsi < 1) {
				return true;
			} else {
				return false;
			}
		},

		async initMap(google, data) {
			//if (window?.google) return window.google;
			try {
				let configData = configDirective.getConfigData();
				let heatMapData = [];
				let bound = new google.maps.LatLngBounds();
				let map_center = configData["site-settings"]["map_center"].split(",");
				let center = new google.maps.LatLng(map_center[0], map_center[1], true);
				let zoom = configData["site-settings"]["map_zoom"] ? configData["site-settings"]["map_zoom"] : 3;

				if (!document.getElementById("data_volume_map")) return;
				// Initialize map with center, zoom and mapTypeId
				const map = new google.maps.Map(document.getElementById("data_volume_map"), {
					center: center,
					zoom: zoom,
					mapTypeId: google.maps.MapTypeId.ROADMAP,
				});

				// console.log("Map data =>", data);
				data = data.filter(d => d.lat_lon !== null);
				let show_default = this.checkMapData(data);

				if (show_default) {
					// if no data, show single test marker in center
					let icon_cgreen = "https://i.imgur.com/CM5c7BE.png";

					let marker = new google.maps.Marker({
						position: center,
						map: map,
						animation: google.maps.Animation.DROP,
						title: "Default Marker",
						icon: icon_cgreen,
					});

					let contentString =
						'<div id="content">' +
						'<p style="margin-top: 15px; font: bold 12px Roboto, serif; color: #34495e;">No data returned from server</p>' +
						"</div>";
					let infowindow = new google.maps.InfoWindow({
						content: contentString,
					});

					setTimeout(() => {
						infowindow.open(map, marker);
					}, 1000);

					google.maps.event.addListener(marker, "click", function () {
						infowindow.open(map, marker);
					});
				} else {
					// console.log('data:',data);

					let locations = {};
					// Data visualization layer and marker point setup
					for (let i = 0; i < data.length; i++) {
						// console.log('map_data:',data[i]);
						let lat_lon = data[i].lat_lon;
						// console.log("lat_lon", lat_lon);
						if (lat_lon && lat_lon !== null) {
							if (!locations[lat_lon]) {
								locations[lat_lon] = data[i];
							} else {
								if (
									new Date(locations[lat_lon].authdate).getTime() <
									new Date(data[i].authdate).getTime()
								) {
									locations[lat_lon] = {
										...data[i],
										weight: locations[lat_lon].weight + data[i].weight,
									};
								}
							}
						}
					}
					// console.log('locations:',locations);
					const keys = Object.keys(locations);
					for (let i = 0; i < keys.length; i++) {
						const key = keys[i];
						const data = locations[key];
						this.addMarker(map, key, data.radio, data, bound, configData);
						heatMapData.push({
							location: new google.maps.LatLng(
								parseFloat(data.lat_lon.split(",")[0]),
								parseFloat(data.lat_lon.split(",")[1])
							),
							wieght: data.weight,
						});
					}

					map.fitBounds(bound);

					if (heatMapData.length > 1) {
						if (this.markerList) {
							this.markerList.forEach(marker => {
								marker.setMap(null);
							});
						}
					}

					let heatmap = new google.maps.visualization.HeatmapLayer({
						data: heatMapData,
					});
					heatmap.setMap(map);
					heatmap.set("radius", 30);

					// Calculate the center of the heatmap data
					let latSum = 0;
					let lonSum = 0;
					heatMapData.forEach(dataPoint => {
						latSum += dataPoint.location.lat();
						lonSum += dataPoint.location.lng();
					});
					const dataCenter = new google.maps.LatLng(latSum / heatMapData.length, lonSum / heatMapData.length);

					// Set map center and initial zoom
					// console.log('dataCenter:',dataCenter);
					map.setCenter(dataCenter);
					map.setZoom(7);

					// Define max and min zoom levels
					const maxZoom = 15;
					const minZoomToShowMarkers = 8;

					// Create "Center Map" button and add it to the map
					const centerControlDiv = document.createElement("div");
					const centerControl = this.createCenterControl(map, bound);

					centerControlDiv.appendChild(centerControl);
					map.controls[google.maps.ControlPosition.TOP_CENTER].push(centerControlDiv);

					// Add zoom_changed event listener to handle changes after the initial zooming
					google.maps.event.addListener(map, "zoom_changed", () => {
						const currentZoom = map.getZoom();
						if (currentZoom <= minZoomToShowMarkers) {
							// Remove markers and show only heatmap
							if (heatmap) {
								heatmap.setMap(map);
							}
							if (this.markerList) {
								this.markerList.forEach(marker => {
									marker.setMap(null);
								});
							}
						} else {
							// Show markers and heatmap
							if (heatmap) {
								heatmap.setMap(null);
							}
							if (this.markerList) {
								this.markerList.forEach(marker => {
									marker.setMap(map);
								});
							}
						}

						// Limit zoom level
						if (currentZoom > maxZoom) {
							map.setZoom(maxZoom);
						}
					});
				}
			} catch (e) {
				if (process.env.NODE_ENV === "dev") {
				}
				console.error("initMap", e);
			}
		},

		addMarker(map, lat_lon, connectiontype, markerInfo, bounds, configData) {
			// console.log('addMarker:',lat_lon,connectiontype,imsi,bounds,configData);

			//let icon_3green = "https://i.imgur.com/vSpGkBd.png";
			//let icon_4green = "https://i.imgur.com/8jLOZnY.png";
			let icon_3yellow = "https://i.imgur.com/SU1eH1v.png";
			let icon_4yellow = "https://i.imgur.com/theJhNx.png";
			//let icon_cgreen = "https://i.imgur.com/CM5c7BE.png";
			let icon_cyellow = "https://i.imgur.com/2eE096C.png";
			let sel_icon = "";

			if (connectiontype === "3G") {
				// yellow triangle
				sel_icon = icon_3yellow;
			} else if (connectiontype === "LTE") {
				// yellow square
				sel_icon = icon_4yellow;
			} else {
				sel_icon = icon_cyellow;
			}

			let latlngStr = lat_lon.split(",", 2);
			let latlng = {lat: parseFloat(latlngStr[0]), lng: parseFloat(latlngStr[1])};

			let auth_date = moment(new Date(markerInfo.authdate)).format("MMM DD, YYYY HH:mm:ss");

			if (auth_date === "Invalid date") {
				auth_date = moment(new Date(markerInfo.date)).format("MMM DD, YYYY HH:mm:ss");
			}
			if (auth_date === "Invalid date") {
				auth_date = "Not Available";
			}

			let contentString =
				'<div id="content" class="p-2">' +
				'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">Last Session: </span> ' +
				auth_date +
				"</p>" +
				'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">Connection Type: </span> ' +
				connectiontype +
				'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">CID: </span> ' +
				markerInfo.cid +
				"</p>" +
				'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">LAC: </span> ' +
				markerInfo.lac +
				"</p>" +
				'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">MCC/MNC: </span> ' +
				markerInfo.mcc +
				markerInfo.mnc +
				"</p>" +
				'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">LAT/LON: </span> ' +
				markerInfo.lat_lon +
				"</p>" +
				(markerInfo.uli
					? '<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">ULI: </span> ' +
						markerInfo.uli
					: "") +
				"</p>" +
				'<p style="font-size: 12px;"><span style="font: bold 12px Roboto, serif; color: #34495e;">Count: </span> ' +
				markerInfo.weight +
				"</p>" +
				"</div>";
			let infowindow = new google.maps.InfoWindow({
				content: contentString,
			});

			let marker = new google.maps.Marker({
				position: latlng,
				map: map,
				title: "Point",
				icon: sel_icon,
				visible: configData["site-settings"]["use_map"] === "markerclusters",
			});

			marker.addListener("click", function () {
				infowindow.open(map, marker);
			});
			// close infowindow when zoom < 15
			google.maps.event.addListener(map, "zoom_changed", function () {
				if (map.getZoom() < 15) {
					infowindow.close();
				}
			});
			// close infowindow when click on map
			google.maps.event.addListener(map, "click", function () {
				infowindow.close();
			});

			if (typeof bounds !== "undefined") {
				// bounds.extend(marker.getPosition());
				bounds.extend(
					new google.maps.LatLng(parseFloat(lat_lon.split(",")[0]), parseFloat(lat_lon.split(",")[1]))
				);
			}
			this.markerList.push(marker);
			return marker;
		},

		createCenterControl(map, bound) {
			const controlButton = document.createElement("button");

			// Set CSS for the control.
			controlButton.style.backgroundColor = "#fff";
			controlButton.style.border = "2px solid #fff";
			controlButton.style.borderRadius = "3px";
			controlButton.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
			controlButton.style.color = "rgb(25,25,25)";
			controlButton.style.cursor = "pointer";
			controlButton.style.fontFamily = "Roboto,Arial,sans-serif";
			controlButton.style.fontSize = "16px";
			controlButton.style.lineHeight = "38px";
			controlButton.style.margin = "8px 0 22px";
			controlButton.style.padding = "0 5px";
			controlButton.style.textAlign = "center";

			controlButton.textContent = "Recenter";
			controlButton.title = "Click to recenter the map";
			controlButton.type = "button";

			// Setup the click event listeners: simply set the map to Chicago.
			controlButton.addEventListener("click", () => {
				map.setCenter(this.startingCenter);
				map.fitBounds(bound);
			});

			return controlButton;
		},

		resetMap() {
			this.loadingStatus = true;
			this.markerList = [];
			this.heatMapData = [];
		},

		/*
      initGradients(period) {
        if (
          typeof document.getElementById("legend" + period) === "undefined" ||
          typeof document.getElementById("legend"+ period).innerHTML === 'undefined' ||
          document.getElementById("legend" + period) === null ||
          document.getElementById("legend" + period).innerHTML === ""
        ) {
          setTimeout(this.initGradients, 1500, period);
          return;
        }
        var gradientCss = "(left";
        for (var i = 0; i < this.gradient.length; ++i) {
          gradientCss += ", " + this.gradient[i];
        }
        gradientCss += ")";
        document.getElementById("legendGradient" + period).style.backgroundColor =  "-webkit-linear-gradient" + gradientCss;
        document.getElementById("legendGradient" + period).style.backgroundColor = "-moz-linear-gradient" + gradientCss;
        document.getElementById("legendGradient" + period).style.backgroundColor = "-o-linear-gradient" + gradientCss;
        document.getElementById("legendGradient" + period).style.backgroundColor = "linear-gradient" + gradientCss;
        var maxIntensity = 10;
        var legendWidth = 250;
        let max = undefined;
        //LegendTitle
        if (
          document.getElementById("legend" + period).innerHTML.indexOf("Data Volume") < 1
        ) {
          if (typeof max === "undefined" || max < 10) {
            let legendCardTitle = document.getElementById('legend' + period);
            var legendGradientCss = document.createElement('div');
            legendGradientCss.innerHTML = "<b>Data Volume (scale 1 - 10)</b>";
            legendCardTitle.appendChild(legendGradientCss)
          } else {
            let legendCardTitle1 = document.getElementById('legend' + period);
            var legendGradientCss1 = document.createElement('div');
            legendGradientCss1.innerHTML = '<b>Data Volume (0 - " + max + " MB)</b>';
            legendCardTitle1.appendChild(legendGradientCss1)

          }
        }

        // Legend Number
        for (var i = 0; i <= maxIntensity; ++i) {
          var offset = (i * legendWidth) / maxIntensity;
          if (i > 0 && i < maxIntensity) {
            offset -= 0.5;
          } else if (i === maxIntensity) {
            offset -= 1;
          }
          let legendCardTitle = document.getElementById('legend' + period);
          let legendCardTitleRule = document.createElement('div');
          legendCardTitleRule.style.position = "absolute";
          legendCardTitleRule.style.left = offset + 5 + 'px';
          legendCardTitleRule.style.top = "2px";
          legendCardTitleRule.style.width =  "1px";
          legendCardTitleRule.style.height =  "3px";
          legendCardTitleRule.style.backgroundColor = "black";
          legendCardTitle.appendChild(legendCardTitleRule);

          let legendCardTitleNumber = document.createElement('div');
          legendCardTitleRule.style.position = "absolute";
          legendCardTitleRule.style.left = offset + 'px';
          legendCardTitleRule.style.top = "2px";
          legendCardTitleRule.style.textAlign = "center";
          legendCardTitleRule.style.fontSize = "0.8em";
          legendCardTitleNumber.style.fontWeight = 'bold';
          legendCardTitleRule.innerHTML = i;
          legendCardTitle.appendChild(legendCardTitleNumber);

        }
      },
      */

		changeDataRegionTab(title) {
			console.warn("changeDataRegionTab:", title);
			this.$emit("changeDataRegionTab", title);
			this.loadingStatus = true;
			this.btnActivated = title;
			this.resetMap();
		},

		dataVolumeRegionToggle() {
			let status = cardOpenStatusDirective.setDataVolumeMapStatus();
			if (status) {
				this.toggleStatus = !this.toggleStatus;
				if (this.toggleStatus) {
					this.icon1 = this.downIcon;
				} else {
					this.icon1 = this.rightIcon;
				}
				this.$root.$emit("dataVolumeTrendsByRegionOpen", this.btnActivated);
			}
		},
	},
};
</script>

<style>
.data-volume-region-container {
	max-width: 100%;
	padding: 0 !important;
}

/*.gradient-body-width {*/
/*  width: 250px;*/
/*  height: 15px;*/
/*  background: -webkit-linear-gradient(left, rgba(102, 255, 0, 0), rgb(102, 255, 0), rgb(147, 255, 0), rgb(193, 255, 0), rgb(238, 255, 0), rgb(244, 227, 0), rgb(249, 198, 0), rgb(255, 170, 0), rgb(255, 113, 0), rgb(255, 57, 0), rgb(255, 0, 0));*/
/*}*/
/*.legendImage {*/
/*  width: 300px!important;*/
/*}*/
</style>
